import Labels from './Labels';
export default Labels;
